import { createAction } from '@reduxjs/toolkit';

export const clearContactDetailsForm = createAction('CLEAR_CONTACT_DETAILS_FORM');
export const dismissContactDetailsToastMessage = createAction('DISMISS_CONTACT_DETAILS_TOAST_MESSAGE');
